<portal-configuration-menu> </portal-configuration-menu>
<hr>

<div class="alert alert-warning" role="alert" *ngIf="_portalConfigurationService.alert">
  {{ _portalConfigurationService.alert | translate }}
</div>

<loading-component *ngIf="_portalConfigurationService.loading"></loading-component>

<form *ngIf="!_portalConfigurationService.loading" [formGroup]="ppconfiguration">

  <fieldset class="fieldsetborder">
    <legend class="main-color">&nbsp;{{ 'COLORS' | translate}} &nbsp;
    </legend>
    <div class="form-row">
      <div class="form-group col-md-3">
        <label>{{ 'MAIN' | translate }} <i class="fa fa-question-circle" aria-hidden="true"
            placement="top"
            [ngbTooltip]="_portalConfigurationService.configuration.mainColor.extra | translate"></i></label>
        <div class="input-group">
          <input class="form-control height-38px" type="color"
            [value]="_portalConfigurationService.configuration.mainColor.name" name="mainColor"
            [(ngModel)]=_portalConfigurationService.configuration.mainColor.name
            formControlName="mainColor">

          <br /><br />
          <button *ngIf="editItem != 'mainColor'" class="btn btn-main-color btn-block"
            (click)="edit('mainColor')">
            {{ 'EDIT' | translate}}
          </button>
          <button *ngIf="editItem == 'mainColor'" class="btn btn-secondary-color btn-block"
            (click)="cancelEdit()">
            {{ 'CANCEL' | translate}}
          </button>
          <button *ngIf="editItem == 'mainColor'" type="submit" class="btn btn-main-color btn-block"
            (click)="update(_portalConfigurationService.configuration.mainColor)">
            {{ 'UPDATE' | translate}}
          </button>
        </div>
      </div>

      <div class="form-group col-md-3">
        <label>{{ 'SECONDARY' | translate }} <i class="fa fa-question-circle" aria-hidden="true"
            placement="top"
            [ngbTooltip]="_portalConfigurationService.configuration.secondaryColor.extra | translate"></i></label>
        <div class="input-group">
          <input class="form-control height-38px" type="color"
            [value]="_portalConfigurationService.configuration.secondaryColor.name"
            name="secondaryColor"
            [(ngModel)]=_portalConfigurationService.configuration.secondaryColor.name
            formControlName="secondaryColor">

          <br /><br />
          <button *ngIf="editItem != 'secondaryColor'" class="btn btn-main-color btn-block"
            (click)="edit('secondaryColor')">
            {{ 'EDIT' | translate}}
          </button>
          <button *ngIf="editItem == 'secondaryColor'" class="btn btn-secondary-color btn-block"
            (click)="cancelEdit()">
            {{ 'CANCEL' | translate}}
          </button>
          <button *ngIf="editItem == 'secondaryColor'" type="submit"
            class="btn btn-main-color btn-block"
            (click)="update(_portalConfigurationService.configuration.secondaryColor)">
            {{ 'UPDATE' | translate}}
          </button>
        </div>
      </div>

      <div class="form-group col-md-3">
        <label>{{ 'BACKGROUND' | translate }} <i class="fa fa-question-circle" aria-hidden="true"
            placement="top"
            [ngbTooltip]="_portalConfigurationService.configuration.backgroundColor.extra | translate"></i></label>
        <div class="input-group">
          <input class="form-control height-38px" type="color"
            [value]="_portalConfigurationService.configuration.backgroundColor.name"
            name="backgroundColor"
            [(ngModel)]=_portalConfigurationService.configuration.backgroundColor.name
            formControlName="backgroundColor">
          <br /><br />
          <button *ngIf="editItem != 'backgroundColor'" class="btn btn-main-color btn-block"
            (click)="edit('backgroundColor')">
            {{ 'EDIT' | translate}}
          </button>
          <button *ngIf="editItem == 'backgroundColor'" class="btn btn-secondary-color btn-block"
            (click)="cancelEdit()">
            {{ 'CANCEL' | translate}}
          </button>
          <button *ngIf="editItem == 'backgroundColor'" type="submit"
            class="btn btn-main-color btn-block"
            (click)="update(_portalConfigurationService.configuration.backgroundColor)">
            {{ 'UPDATE' | translate}}
          </button>
        </div>
      </div>

      <div class="form-group col-md-3">
        <label>{{ 'LOGO_BACKGROUND' | translate }} <i class="fa fa-question-circle"
            aria-hidden="true" placement="top"
            [ngbTooltip]="_portalConfigurationService.configuration.logoBackgroundColor.extra | translate"></i></label>
        <div class="input-group">
          <input class="form-control height-38px" type="color"
            [value]="_portalConfigurationService.configuration.logoBackgroundColor.name"
            name="logoBackgroundColor"
            [(ngModel)]=_portalConfigurationService.configuration.logoBackgroundColor.name
            formControlName="logoBackgroundColor">
          <br /><br />
          <button *ngIf="editItem != 'logoBackgroundColor'" class="btn btn-main-color btn-block"
            (click)="edit('logoBackgroundColor')">
            {{ 'EDIT' | translate}}
          </button>
          <button *ngIf="editItem == 'logoBackgroundColor'"
            class="btn btn-secondary-color btn-block" (click)="cancelEdit()">
            {{ 'CANCEL' | translate}}
          </button>
          <button *ngIf="editItem == 'logoBackgroundColor'" type="submit"
            class="btn btn-main-color btn-block"
            (click)="update(_portalConfigurationService.configuration.logoBackgroundColor)">
            {{ 'UPDATE' | translate}}
          </button>
        </div>
      </div>
    </div>
  </fieldset>


  <br>
  <br>
  <div class="form-row">
    <div class="form-group col-md-8">
      <label>{{ 'LOGO' | translate }} <i class="fa fa-question-circle" aria-hidden="true"
          placement="top"
          [ngbTooltip]="_portalConfigurationService.configuration.logoURL.extra | translate"></i></label>
      <div class="input-group mb-3" *ngIf="editItem != 'logoUploadFile'">
        <input class="form-control" type="text"
          [value]="_portalConfigurationService.configuration.logoURL.name" name="logoURL"
          [(ngModel)]=_portalConfigurationService.configuration.logoURL.name
          formControlName="logoURL">
      </div>
      <div class="input-group mb-3" *ngIf="editItem == 'logoUploadFile'">
        <input type="file" class="form-control custom-file-input" id="logoURL"
          formControlName="logoUploadFile" name="logoUploadFile" (ngModelChange)="putNameInField()">
        <label class="custom-file-label" id="fileLabel" for="logoURL">Choose file</label>
      </div>
    </div>
    <div class="form-group col-md-2" *ngIf="editItem != 'logoURL' && editItem != 'logoUploadFile'">
      <label>&nbsp;</label>
      <button class="btn btn-main-color btn-block" (click)="edit('logoURL')">
        {{ 'EDIT_URL' | translate}}
      </button>
    </div>
    <div class="form-group col-md-2" *ngIf="editItem != 'logoURL' && editItem != 'logoUploadFile'">
      <label>&nbsp;</label>
      <button class="btn btn-main-color btn-block" (click)="edit('logoUploadFile')">
        {{ 'UPLOAD_FILE' | translate}}
      </button>
    </div>
    <div class="form-group col-md-2" *ngIf="editItem == 'logoURL' || editItem == 'logoUploadFile'">
      <label>&nbsp;</label>
      <button class="btn btn-secondary-color btn-block" (click)="cancelEdit()">
        {{ 'CANCEL' | translate}}
      </button>
    </div>
    <div class="form-group col-md-2" *ngIf="editItem == 'logoURL' || editItem == 'logoUploadFile'">
      <label>&nbsp;</label>
      <button type="submit" class="btn btn-main-color btn-block"
        (click)="update(_portalConfigurationService.configuration.logoURL)">
        <span *ngIf="editItem != 'logoUploadFile'">{{ 'UPDATE' | translate}}</span>
        <span *ngIf="editItem == 'logoUploadFile'">{{ 'UPLOAD' | translate}}</span>
      </button>
    </div>
  </div>

  <div class="form-row">
    <div class="form-group col-md-8">
      <label>{{ 'FAVICON' | translate }} <i class="fa fa-question-circle" aria-hidden="true"
          placement="top"
          [ngbTooltip]="_portalConfigurationService.configuration.faviconURL.extra | translate"></i></label>
      <div class="input-group mb-3" *ngIf="editItem != 'faviconUploadFile'">
        <input class="form-control" type="text"
          [value]="_portalConfigurationService.configuration.faviconURL.name" name="faviconURL"
          [(ngModel)]=_portalConfigurationService.configuration.faviconURL.name
          formControlName="faviconURL">
      </div>
      <div class="input-group mb-3" *ngIf="editItem == 'faviconUploadFile'">
        <input type="file" class="form-control custom-file-input" id="faviconURL"
          formControlName="faviconUploadFile" name="faviconUploadFile"
          (ngModelChange)="putNameInField()">
        <label class="custom-file-label" id="fileLabel" for="faviconURL">Choose file</label>
      </div>
    </div>
    <div class="form-group col-md-2"
      *ngIf="editItem != 'faviconURL' && editItem != 'faviconUploadFile'">
      <label>&nbsp;</label>
      <button class="btn btn-main-color btn-block" (click)="edit('faviconURL')">
        {{ 'EDIT_URL' | translate}}
      </button>
    </div>
    <div class="form-group col-md-2"
      *ngIf="editItem != 'faviconURL' && editItem != 'faviconUploadFile'">
      <label>&nbsp;</label>
      <button class="btn btn-main-color btn-block" (click)="edit('faviconUploadFile')">
        {{ 'UPLOAD_FILE' | translate}}
      </button>
    </div>
    <div class="form-group col-md-2"
      *ngIf="editItem == 'faviconURL' || editItem == 'faviconUploadFile'">
      <label>&nbsp;</label>
      <button class="btn btn-secondary-color btn-block" (click)="cancelEdit()">
        {{ 'CANCEL' | translate}}
      </button>
    </div>
    <div class="form-group col-md-2"
      *ngIf="editItem == 'faviconURL' || editItem == 'faviconUploadFile'">
      <label>&nbsp;</label>
      <button type="submit" class="btn btn-main-color btn-block"
        (click)="update(_portalConfigurationService.configuration.faviconURL)">
        <span *ngIf="editItem != 'faviconUploadFile'">{{ 'UPDATE' | translate}}</span>
        <span *ngIf="editItem == 'faviconUploadFile'">{{ 'UPLOAD' | translate}}</span>
      </button>
    </div>
  </div>

  <div class="form-row">
    <div class="form-group col-md-8">
      <label>{{ 'NAME' | translate }} <i class="fa fa-question-circle" aria-hidden="true"
          placement="top"
          [ngbTooltip]="_portalConfigurationService.configuration.name.extra | translate"></i></label>
      <div class="input-group mb-3">
        <input class="form-control" type="text"
          [value]="_portalConfigurationService.configuration.name.name" name="name"
          [(ngModel)]=_portalConfigurationService.configuration.name.name formControlName="name">
      </div>
    </div>
    <div class="form-group col-md-4" *ngIf="editItem != 'name'">
      <label>&nbsp;</label>
      <button class="btn btn-main-color btn-block" (click)="edit('name')">
        {{ 'EDIT' | translate}}
      </button>
    </div>
    <div class="form-group col-md-2" *ngIf="editItem == 'name'">
      <label>&nbsp;</label>
      <button class="btn btn-secondary-color btn-block" (click)="cancelEdit()">
        {{ 'CANCEL' | translate}}
      </button>
    </div>
    <div class="form-group col-md-2" *ngIf="editItem == 'name'">
      <label>&nbsp;</label>
      <button type="submit" class="btn btn-main-color btn-block"
        (click)="update(_portalConfigurationService.configuration.name)">
        {{ 'UPDATE' | translate}}
      </button>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-md-8">
      <label>{{ 'ADDRESS' | translate }} <i class="fa fa-question-circle" aria-hidden="true"
          placement="top"
          [ngbTooltip]="_portalConfigurationService.configuration.address.extra | translate"></i></label>
      <div class="input-group mb-3">
        <input class="form-control" type="text"
          [value]="_portalConfigurationService.configuration.address.name" name="address"
          [(ngModel)]=_portalConfigurationService.configuration.address.name
          formControlName="address">
      </div>
    </div>
    <div class="form-group col-md-4" *ngIf="editItem != 'address'">
      <label>&nbsp;</label>
      <button class="btn btn-main-color btn-block" (click)="edit('address')">
        {{ 'EDIT' | translate}}
      </button>
    </div>
    <div class="form-group col-md-2" *ngIf="editItem == 'address'">
      <label>&nbsp;</label>
      <button class="btn btn-secondary-color btn-block" (click)="cancelEdit()">
        {{ 'CANCEL' | translate}}
      </button>
    </div>
    <div class="form-group col-md-2" *ngIf="editItem == 'address'">
      <label>&nbsp;</label>
      <button type="submit" class="btn btn-main-color btn-block"
        (click)="update(_portalConfigurationService.configuration.address)">
        {{ 'UPDATE' | translate}}
      </button>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-md-8">
      <label>{{ 'PHONE_NUMBER' | translate }} <i class="fa fa-question-circle" aria-hidden="true"
          placement="top"
          [ngbTooltip]="_portalConfigurationService.configuration.phoneNumber.extra | translate"></i></label>
      <div class="input-group mb-3">
        <input class="form-control" type="text"
          [value]="_portalConfigurationService.configuration.phoneNumber.name" name="phoneNumber"
          [(ngModel)]=_portalConfigurationService.configuration.phoneNumber.name
          formControlName="phoneNumber">
      </div>
    </div>
    <div class="form-group col-md-4" *ngIf="editItem != 'phoneNumber'">
      <label>&nbsp;</label>
      <button class="btn btn-main-color btn-block" (click)="edit('phoneNumber')">
        {{ 'EDIT' | translate}}
      </button>
    </div>
    <div class="form-group col-md-2" *ngIf="editItem == 'phoneNumber'">
      <label>&nbsp;</label>
      <button class="btn btn-secondary-color btn-block" (click)="cancelEdit()">
        {{ 'CANCEL' | translate}}
      </button>
    </div>
    <div class="form-group col-md-2" *ngIf="editItem == 'phoneNumber'">
      <label>&nbsp;</label>
      <button type="submit" class="btn btn-main-color btn-block"
        (click)="update(_portalConfigurationService.configuration.phoneNumber)">
        {{ 'UPDATE' | translate}}
      </button>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-md-8">
      <label>{{ 'EMAIL' | translate }} <i class="fa fa-question-circle" aria-hidden="true"
          placement="top"
          [ngbTooltip]="_portalConfigurationService.configuration.email.extra | translate"></i></label>
      <div class="input-group mb-3">
        <input class="form-control" type="text"
          [value]="_portalConfigurationService.configuration.email.name" name="email"
          [(ngModel)]=_portalConfigurationService.configuration.email.name formControlName="email">
      </div>
    </div>
    <div class="form-group col-md-4" *ngIf="editItem != 'email'">
      <label>&nbsp;</label>
      <button class="btn btn-main-color btn-block" (click)="edit('email')">
        {{ 'EDIT' | translate}}
      </button>
    </div>
    <div class="form-group col-md-2" *ngIf="editItem == 'email'">
      <label>&nbsp;</label>
      <button class="btn btn-secondary-color btn-block" (click)="cancelEdit()">
        {{ 'CANCEL' | translate}}
      </button>
    </div>
    <div class="form-group col-md-2" *ngIf="editItem == 'email'">
      <label>&nbsp;</label>
      <button type="submit" class="btn btn-main-color btn-block"
        (click)="update(_portalConfigurationService.configuration.email)">
        {{ 'UPDATE' | translate}}
      </button>
    </div>
  </div>

  <fieldset class="fieldsetborder"
    *ngIf="_portalConfigurationService.configuration.messageInPortal">
    <legend class="main-color">&nbsp;{{ 'MESSAGE_IN_PORTAL' | translate}} &nbsp;
    </legend>
    <div class="form-row">
      <div class="form-check">
        <input class="form-check-input" type="checkbox"
          value="_portalConfigurationService.configuration.messageInPortal.name"
          name="messageInPortal" formControlName="messageInPortal">
        <label class="form-check-label" for="defaultCheck1">
          {{ 'ACTIVE_MESSAGE_IN_PORTAL' | translate}}
        </label>
      </div>
    </div>
    <div class="margin-bottom-50">
      <button *ngIf="editItem != 'messageInPortal'" class="btn btn-main-color float-right"
        (click)="edit('messageInPortal')">
        {{ 'EDIT' | translate}}
      </button>
      <button *ngIf="editItem == 'messageInPortal'" class="btn btn-secondary-color float-right"
        (click)="cancelEdit()">
        {{ 'CANCEL' | translate}}
      </button>
      <button *ngIf="editItem == 'messageInPortal'" type="submit"
        class="btn btn-main-color float-right" (click)="update('messageInPortal')">
        {{ 'UPDATE' | translate}}
      </button>
    </div>

    <div class="form-row" *ngIf="_portalConfigurationService.configuration.textOnMessageInPortal">
      <div class="form-group col-md-8">
        <label>{{ 'TEXT_ON_MESSAGE_IN_PORTAL' | translate }} <i class="fa fa-question-circle"
            aria-hidden="true" placement="top"
            [ngbTooltip]="_portalConfigurationService.configuration.textOnMessageInPortal.extra | translate"></i></label>
        <div class="input-group mb-3">
          <textarea class="form-control" type="text"
            [value]="_portalConfigurationService.configuration.textOnMessageInPortal.name"
            name="textOnMessageInPortal"
            [(ngModel)]=_portalConfigurationService.configuration.textOnMessageInPortal.name
            formControlName="textOnMessageInPortal"></textarea>
        </div>
      </div>
      <div class="form-group col-md-4" *ngIf="editItem != 'textOnMessageInPortal'">
        <label>&nbsp;</label>
        <button class="btn btn-main-color btn-block" (click)="edit('textOnMessageInPortal')">
          {{ 'EDIT' | translate}}
        </button>
      </div>
      <div class="form-group col-md-2" *ngIf="editItem == 'textOnMessageInPortal'">
        <label>&nbsp;</label>
        <button class="btn btn-secondary-color btn-block" (click)="cancelEdit()">
          {{ 'CANCEL' | translate}}
        </button>
      </div>
      <div class="form-group col-md-2" *ngIf="editItem == 'textOnMessageInPortal'">
        <label>&nbsp;</label>
        <button type="submit" class="btn btn-main-color btn-block"
          (click)="update(_portalConfigurationService.configuration.textOnMessageInPortal)">
          {{ 'UPDATE' | translate}}
        </button>
      </div>
    </div>


  </fieldset>

  <hr>
  <strong>{{ 'CACHED_VALUES' | translate}}</strong> - <small>{{ 'REMENBER_CLEAR_CACHE' |
    translate}}</small>

  <hr>

  <div class="form-row">
    <div class="form-group col-md-3"
      *ngIf="_portalConfigurationService.configuration.percentageFreeslotsShowed">
      <label>{{ 'PERCENTAGE_FREESLOTS_SHOWED' | translate }} <i class="fa fa-question-circle"
          aria-hidden="true" placement="top"
          [ngbTooltip]="_portalConfigurationService.configuration.percentageFreeslotsShowed.extra | translate"></i></label>
      <div class="input-group">
        <input class="form-control height-38px" type="number"
          [value]="_portalConfigurationService.configuration.percentageFreeslotsShowed.name"
          name="percentageFreeslotsShowed"
          [(ngModel)]=_portalConfigurationService.configuration.percentageFreeslotsShowed.name
          formControlName="percentageFreeslotsShowed">

        <br /><br />
        <button *ngIf="editItem != 'percentageFreeslotsShowed'" class="btn btn-main-color btn-block"
          (click)="edit('percentageFreeslotsShowed')">
          {{ 'EDIT' | translate}}
        </button>
        <button *ngIf="editItem == 'percentageFreeslotsShowed'"
          class="btn btn-secondary-color btn-block" (click)="cancelEdit()">
          {{ 'CANCEL' | translate}}
        </button>
        <button *ngIf="editItem == 'percentageFreeslotsShowed'" type="submit"
          class="btn btn-main-color btn-block"
          (click)="update(_portalConfigurationService.configuration.percentageFreeslotsShowed)">
          {{ 'UPDATE' | translate}}
        </button>
      </div>
    </div>
    <div class="form-group col-md-3"
      *ngIf="_portalConfigurationService.configuration.maxMonthsSearch">
      <label>{{ 'MAX_MONTHS_FREESLOTS_SEARCH' | translate }} <i class="fa fa-question-circle"
          aria-hidden="true" placement="top"
          [ngbTooltip]="_portalConfigurationService.configuration.maxMonthsSearch.extra | translate"></i></label>
      <div class="input-group">
        <input class="form-control height-38px" type="number"
          [value]="_portalConfigurationService.configuration.maxMonthsSearch.name"
          name="maxMonthsSearch"
          [(ngModel)]=_portalConfigurationService.configuration.maxMonthsSearch.name
          formControlName="maxMonthsSearch">

        <br /><br />
        <button *ngIf="editItem != 'maxMonthsSearch'" class="btn btn-main-color btn-block"
          (click)="edit('maxMonthsSearch')">
          {{ 'EDIT' | translate}}
        </button>
        <button *ngIf="editItem == 'maxMonthsSearch'" class="btn btn-secondary-color btn-block"
          (click)="cancelEdit()">
          {{ 'CANCEL' | translate}}
        </button>
        <button *ngIf="editItem == 'maxMonthsSearch'" type="submit"
          class="btn btn-main-color btn-block"
          [disabled]="ppconfiguration.controls.maxMonthsSearch.errors"
          (click)="update(_portalConfigurationService.configuration.maxMonthsSearch)">
          {{ 'UPDATE' | translate}}
        </button>

        <div class="alert alert-danger mt-1 full-width" role="alert"
          *ngIf="ppconfiguration.controls.maxMonthsSearch.errors">
          {{ 'INVALID_RANGE' | translate}}
        </div>
      </div>
    </div>

    <div class="form-group col-md-3"
      *ngIf="_portalConfigurationService.configuration.loginAttempsBeforeBlock">
      <label>{{ 'LOGIN_ATTEMPS_BEFORE_BLOCK' | translate }} <i class="fa fa-question-circle"
          aria-hidden="true" placement="top"
          [ngbTooltip]="_portalConfigurationService.configuration.loginAttempsBeforeBlock.extra | translate"></i></label>
      <div class="input-group">
        <input class="form-control height-38px" type="number"
          [value]="_portalConfigurationService.configuration.loginAttempsBeforeBlock.name"
          name="loginAttempsBeforeBlock"
          [(ngModel)]=_portalConfigurationService.configuration.loginAttempsBeforeBlock.name
          formControlName="loginAttempsBeforeBlock">

        <br /><br />
        <button *ngIf="editItem != 'loginAttempsBeforeBlock'" class="btn btn-main-color btn-block"
          (click)="edit('loginAttempsBeforeBlock')">
          {{ 'EDIT' | translate}}
        </button>
        <button *ngIf="editItem == 'loginAttempsBeforeBlock'"
          class="btn btn-secondary-color btn-block" (click)="cancelEdit()">
          {{ 'CANCEL' | translate}}
        </button>
        <button *ngIf="editItem == 'loginAttempsBeforeBlock'" type="submit"
          class="btn btn-main-color btn-block"
          (click)="update(_portalConfigurationService.configuration.loginAttempsBeforeBlock)">
          {{ 'UPDATE' | translate}}
        </button>
      </div>
    </div>

    <div class="form-group col-md-3"
      *ngIf="_portalConfigurationService.configuration.tokenTimeoutMinutes">
      <label>{{ 'TOKEN_TIMEOUT_MINUTES' | translate }} <i class="fa fa-question-circle"
          aria-hidden="true" placement="top"
          [ngbTooltip]="_portalConfigurationService.configuration.tokenTimeoutMinutes.extra | translate"></i></label>
      <div class="input-group">
        <input class="form-control height-38px" type="number"
          [value]="_portalConfigurationService.configuration.tokenTimeoutMinutes.name"
          name="tokenTimeoutMinutes"
          [(ngModel)]=_portalConfigurationService.configuration.tokenTimeoutMinutes.name
          formControlName="tokenTimeoutMinutes">

        <br /><br />
        <button *ngIf="editItem != 'tokenTimeoutMinutes'" class="btn btn-main-color btn-block"
          (click)="edit('tokenTimeoutMinutes')">
          {{ 'EDIT' | translate}}
        </button>
        <button *ngIf="editItem == 'tokenTimeoutMinutes'" class="btn btn-secondary-color btn-block"
          (click)="cancelEdit()">
          {{ 'CANCEL' | translate}}
        </button>
        <button *ngIf="editItem == 'tokenTimeoutMinutes'" type="submit"
          class="btn btn-main-color btn-block"
          (click)="update(_portalConfigurationService.configuration.tokenTimeoutMinutes)">
          {{ 'UPDATE' | translate}}
        </button>
      </div>
    </div>

    <div class="form-group col-md-3"
      *ngIf="_portalConfigurationService.configuration.pinExpirationDays">
      <label>{{ 'PIN_EXPIRATION_DAYS' | translate }} <i class="fa fa-question-circle"
          aria-hidden="true" placement="top"
          [ngbTooltip]="_portalConfigurationService.configuration.pinExpirationDays.extra | translate"></i></label>
      <div class="input-group">
        <input class="form-control height-38px" type="number"
          [value]="_portalConfigurationService.configuration.pinExpirationDays.name"
          name="tokenTimeoutMinutes"
          [(ngModel)]=_portalConfigurationService.configuration.pinExpirationDays.name
          formControlName="pinExpirationDays">

        <br /><br />
        <button *ngIf="editItem != 'pinExpirationDays'" class="btn btn-main-color btn-block"
          (click)="edit('pinExpirationDays')">
          {{ 'EDIT' | translate}}
        </button>
        <button *ngIf="editItem == 'pinExpirationDays'" class="btn btn-secondary-color btn-block"
          (click)="cancelEdit()">
          {{ 'CANCEL' | translate}}
        </button>
        <button *ngIf="editItem == 'pinExpirationDays'" type="submit"
          class="btn btn-main-color btn-block"
          [disabled]="ppconfiguration.controls.pinExpirationDays.errors"
          (click)="update(_portalConfigurationService.configuration.pinExpirationDays)">
          {{ 'UPDATE' | translate}}
        </button>
        <div class="alert alert-danger mt-1 full-width" role="alert"
          *ngIf="ppconfiguration.controls.pinExpirationDays.errors">
          {{ 'INVALID_RANGE' | translate}}
        </div>
      </div>
    </div>
  </div>

  <hr>


  <fieldset class="fieldsetborder border-danger margin-bottom-50"
    *ngIf="_portalConfigurationService.configuration.maintenanceMode">
    <legend class="text-danger">&nbsp;{{ 'DANGER_ZONE' | translate}} &nbsp;
    </legend>
    <div class="form-row">
      <div class="form-check">
        <input class="form-check-input" type="checkbox"
          value="_portalConfigurationService.configuration.maintenanceMode.name"
          name="maintenanceMode" formControlName="maintenanceMode">
        <label class="form-check-label" for="defaultCheck1">
          {{ 'MAINTENANCE_MODE' | translate}}
        </label>
      </div>
    </div>
    <div class="margin-bottom-50">
      <button *ngIf="editItem != 'maintenanceMode'" class="btn btn-danger float-right"
        (click)="edit('maintenanceMode')">
        {{ 'EDIT' | translate}}
      </button>
      <button *ngIf="editItem == 'maintenanceMode'" class="btn btn-secondary-color float-right"
        (click)="cancelEdit()">
        {{ 'CANCEL' | translate}}
      </button>
      <button *ngIf="editItem == 'maintenanceMode'" type="submit" class="btn btn-danger float-right"
        (click)="update('maintenanceMode')">
        {{ 'UPDATE' | translate}}
      </button>
    </div>

    <div class="form-row" *ngIf="_portalConfigurationService.configuration.usersForMaintenanceMode">
      <div class="form-group col-md-8">
        <label>{{ 'USERS_FOR_MAINTENANCE_MODE' | translate }} <i class="fa fa-question-circle"
            aria-hidden="true" placement="top"
            [ngbTooltip]="_portalConfigurationService.configuration.usersForMaintenanceMode.extra | translate"></i></label>
        <div class="input-group mb-3">
          <input class="form-control" type="text"
            [value]="_portalConfigurationService.configuration.usersForMaintenanceMode.name"
            name="textOnMaintenanceMode"
            [(ngModel)]=_portalConfigurationService.configuration.usersForMaintenanceMode.name
            formControlName="usersForMaintenanceMode">
        </div>
      </div>
      <div class="form-group col-md-4" *ngIf="editItem != 'usersForMaintenanceMode'">
        <label>&nbsp;</label>
        <button class="btn btn-main-color btn-block" (click)="edit('usersForMaintenanceMode')">
          {{ 'EDIT' | translate}}
        </button>
      </div>
      <div class="form-group col-md-2" *ngIf="editItem == 'usersForMaintenanceMode'">
        <label>&nbsp;</label>
        <button class="btn btn-secondary-color btn-block" (click)="cancelEdit()">
          {{ 'CANCEL' | translate}}
        </button>
      </div>
      <div class="form-group col-md-2" *ngIf="editItem == 'usersForMaintenanceMode'">
        <label>&nbsp;</label>
        <button type="submit" class="btn btn-main-color btn-block"
          (click)="update(_portalConfigurationService.configuration.usersForMaintenanceMode)">
          {{ 'UPDATE' | translate}}
        </button>
      </div>
    </div>

    <div class="form-row" *ngIf="_portalConfigurationService.configuration.textOnMaintenanceMode">
      <div class="form-group col-md-8">
        <label>{{ 'TEXT_ON_MAINTENANCE_MODE' | translate }} <i class="fa fa-question-circle"
            aria-hidden="true" placement="top"
            [ngbTooltip]="_portalConfigurationService.configuration.textOnMaintenanceMode.extra | translate"></i></label>
        <div class="input-group mb-3">
          <textarea class="form-control" type="text"
            [value]="_portalConfigurationService.configuration.textOnMaintenanceMode.name"
            name="textOnMaintenanceMode"
            [(ngModel)]=_portalConfigurationService.configuration.textOnMaintenanceMode.name
            formControlName="textOnMaintenanceMode"></textarea>
        </div>
      </div>
      <div class="form-group col-md-4" *ngIf="editItem != 'textOnMaintenanceMode'">
        <label>&nbsp;</label>
        <button class="btn btn-main-color btn-block" (click)="edit('textOnMaintenanceMode')">
          {{ 'EDIT' | translate}}
        </button>
      </div>
      <div class="form-group col-md-2" *ngIf="editItem == 'textOnMaintenanceMode'">
        <label>&nbsp;</label>
        <button class="btn btn-secondary-color btn-block" (click)="cancelEdit()">
          {{ 'CANCEL' | translate}}
        </button>
      </div>
      <div class="form-group col-md-2" *ngIf="editItem == 'textOnMaintenanceMode'">
        <label>&nbsp;</label>
        <button type="submit" class="btn btn-main-color btn-block"
          (click)="update(_portalConfigurationService.configuration.textOnMaintenanceMode)">
          {{ 'UPDATE' | translate}}
        </button>
      </div>
    </div>


  </fieldset>

</form>